<template>
  <div class="page-footer-container">
    <div class="footer-header">
      <div class="left">
        <div class="logo">
          <img src="@/assets/image/footer-logo.png" alt="" />
        </div>
      </div>
      <div class="right">
        <div class="nav-bar">
          <ul>
            <li
              v-for="(item, index) in navData"
              :key="index"
              @click="navTo(index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-footer">
      <span>Copyright © 2020 CHANGE. All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navData: [
        "首页",
        "案例展示",
        "解决方案",
        "服务内容",
        "联系我们",
        "关于我们",
      ],
    };
  },
  methods: {
    navTo(index) {
      if (index != this.$route.query.menuIndex) {
        if (index == 0) {
          this.$router.push("/home");
        } else {
          this.$router.push({
            path: "/details",
            query: {
              menuIndex: index,
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-footer-container {
  width: 100%;
  height: 300px;
  background: #ffffff;
  .footer-header {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 60px 0 0 0;
    .left {
      .logo {
        img {
          display: block;
          width: 160px;
        }
      }
    }
    .right {
      .nav-bar {
        ul,
        li {
          margin: 0;
          padding: 0;
          list-style-type: none;
        }
        ul {
          display: flex;
          li {
            margin-left: 40px;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #5e5e5e;
            cursor: pointer;
            user-select: none;
            &:active {
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
  .footer-footer {
    margin-top: 100px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #5e5e5e;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageFooter.vue